@if (useSlideToggle()) {
  <div class="layer-container pb-4 pt-4" [ngClass]="{ 'border-b border-primary-accumin-black-05': !isLast }">
    <div class="flex flex-row justify-between items-center">
      <h4 class="!my-0 !text-sm">
        <button
          type="button"
          class="cursor-pointer bg-transparent p-0 text-left"
          [attr.aria-label]="'Toggle ' + viewModel().displayName"
          (click)="toggleLayerActivation()"
          (keydown)="onKeydown($event)"
        >
          {{ viewModel().displayName }}
        </button>
      </h4>
      <mat-slide-toggle [formControl]="form().controls.isActivated" hideIcon="true" />
    </div>
    <div class="mt-2">
      <div></div>
      <div>
        {{ viewModel().displayInfoText }}
      </div>
    </div>
  </div>
} @else {
  <div class="mt-2 flex items-center">
    <mat-checkbox
      [checked]="form().controls.isActivated.value"
      (change)="form().controls.isActivated.setValue($event.checked)"
      class="ml-0 pl-0"
    />
    <button
      type="button"
      class="cursor-pointer bg-transparent p-0 text-left"
      [attr.aria-label]="'Toggle ' + viewModel().displayName"
      (click)="toggleLayerActivation()"
      (keydown)="onKeydown($event)"
    >
      {{ viewModel().displayName }}
    </button>
  </div>
  <div class="mt-2">
    <app-expandable-text [text]="viewModel().displayInfoText" />
  </div>
}
